/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum RawProfileLayoutAliases {
  CARD_ALTERNATIVE_LOGIN = 'card-alternative-login',
  CARD_HEALTH_INFORMATION_RAW_PROFILE_LAYOUT = 'card-health-information-raw-profile-layout',
  CARD_INFORMATION_RAW_PROFILE_LAYOUT = 'card-information-raw-profile-layout',
  CARD_INSURANCES = 'card-insurances',
  CARD_PERSONAL_CONTACT_RAW_PROFILE_LAYOUT = 'card-personal-contact-raw-profile-layout',
  CARD_PERSONAL_INFORMATION_RAW_PROFILE_LAYOUT = 'card-personal-information-raw-profile-layout',
  CARD_SECURITY_AUTHENTICATION = 'card-security-authentication',
  FRAGMENT_ALTERNATIVE_LOGIN_RAW_PROFILE_LAYOUT = 'fragment-alternative-login-raw-profile-layout',
  FRAGMENT_HEALTH_INFORMATION_RAW_PROFILE_LAYOUT = 'fragment-health-information-raw-profile-layout',
  FRAGMENT_INFORMATION_RAW_PROFILE_LAYOUT = 'fragment-information-raw-profile-layout',
  FRAGMENT_INSURANCES = 'fragment-insurances',
  FRAGMENT_PERSONAL_CONTACT_RAW_PROFILE_LAYOUT = 'fragment-personal-contact-raw-profile-layout',
  FRAGMENT_PERSONAL_INFORMATION_RAW_PROFILE_LAYOUT = 'fragment-personal-information-raw-profile-layout',
  FRAGMENT_SECURITY_AUTHENTICATION = 'fragment-security-authentication',
  LAYOUT_PROFILE = 'layout-profile',
  PANEL_ALTERNATIVE_LOGIN = 'panel-alternative-login',
  PANEL_CARD_ALTERNATIVE_LOGIN_CONTROL_VISIBILITY = 'panel-card-alternative-login-control-visibility',
  PANEL_CARD_SECURITY_CONTROL = 'panel-card-security-control',
  PANEL_HEALTH_INFORMATION_RAW_PROFILE_LAYOUT = 'panel-health-information-raw-profile-layout',
  PANEL_INFORMATION_RAW_PROFILE_LAYOUT = 'panel-information-raw-profile-layout',
  PANEL_INSURANCES = 'panel-insurances',
  PANEL_PERSONAL_CONTACT_RAW_PROFILE_LAYOUT = 'panel-personal-contact-raw-profile-layout',
  PANEL_PERSONAL_INFORMATION_RAW_PROFILE_LAYOUT = 'panel-personal-information-raw-profile-layout',
  PANEL_SECURITY_AUTHENTICATION = 'panel-security-authentication',
  RAW_PANEL_PROFILE = 'raw-panel-profile',
  RAW_PROFILE_LAYOUT = 'raw-profile-layout',
}
export { RawProfileLayoutAliases };
